import * as React from 'react';
import ModuleData from "./ModuleData";
import ModulSpacer from "../ModulSpacer";
import l10n from "diy/util/l10n";
import { autoprefixer } from "../../material-ui/autoprefixer";
import Slider from "material-ui/Slider";

import { EditViewProps } from "../interfaces";

interface SpacerEditViewProps extends EditViewProps<ModuleData>, React.Props<SpacerEditView> {
}

export default class SpacerEditView extends React.Component<SpacerEditViewProps, {}> {

    getStyles() {
        return {
            root: autoprefixer({
                display: "flex",
                marginRight: 12,
                marginLeft: 12
            }),
            left: autoprefixer({
                marginRight: 12,
                alignSelf: "center",
                fontSize: 12
            }),
            right: autoprefixer({
                marginLeft: 12,
                flexGrow: 1,
                maxWidth: 812
            }),
            slider: {
                maxWidth: 800,
                marginBottom: -24, // XXX to compensate the excessive margin put in an inner element of the slider
                marginTop: 16
            },
            spacing: autoprefixer({
                alignSelf: "center",
                marginLeft: 12,
                fontSize: 12
            })
        };
    }

    render() {
        const styles = this.getStyles();

        return (
            <div style={styles.root}>
                <div style={styles.left}>{l10n("module.spacer.heightLabel")}</div>
                <div style={styles.right}>
                    <Slider
                        data-test-id="module-spacer-slider"
                        style={styles.slider}
                        defaultValue={this.props.payload.heightInPixels}
                        onChange={this.onHeightChange}
                        name="spacer"
                        value={this.props.payload.heightInPixels}
                        min={ModulSpacer.MIN_HEIGHT}
                        max={ModulSpacer.MAX_HEIGHT}
                        step={1}
                    />
                 </div>
                <div style={styles.spacing}>
                    {this.props.payload.heightInPixels} px
                </div>
            </div>
        );
    }

    private onHeightChange = (e: React.MouseEvent<{}>, value: number) => {
        this.setHeight(value);
    };

    private setHeight(value: number) {
        value = Math.max(ModulSpacer.MIN_HEIGHT, Math.min(ModulSpacer.MAX_HEIGHT, value));
        this.props.onDataChange(
            {
                heightInPixels: value
            } as ModuleData
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/spacer/EditView.tsx
 **/